export default __webpack_public_path__ + "static/media/android_app_icon_no_shadow.7c67ac7f.png";